import { SportsGroupedByDateRequest } from "sb-bff-integration";
export const datesQueryFactory = (from, timeRange, sportId) => {
    return {
        id: sportId,
        eventState: SportsGroupedByDateRequest.EventStateEnum.PreLive,
        dateRange: {
            from,
            timeRange
        }
    };
};
//# sourceMappingURL=DatesQueries.js.map